import { createSlice } from '@reduxjs/toolkit'
import { defineds } from '../../@core/components/datePickerAction/utils/utils.js'

/** Default range (mois courant → aujourd’hui). Réutilisé au reset navigation. */
export const getDefaultDatePickerRange = () => [
  {
    startDate: defineds.startOfMonth,
    endDate: defineds.endOfToday,
    key: 'selection',
  },
]

const initialState = {
  datePicker: getDefaultDatePickerRange(),
}

export const datePickerSlice = createSlice({
  name: 'datePicker',
  initialState,
  reducers: {
    setDatePicker: (state, action) => {
      state.datePicker = action.payload
    },
    resetDatePicker: () => ({
      datePicker: getDefaultDatePickerRange(),
    }),
  }
})

export const { setDatePicker, resetDatePicker } = datePickerSlice.actions

export const selectDatePicker = (state) => state.datePicker

export default datePickerSlice.reducer
